module.exports = __webpack_public_path__ + "static/media/blurredAbandonedCart.55fdb4f2.svg";